import React, { useEffect, useState } from "react";
import useHTTP from "@/hooks/useHTTP.mjs";
import runAsync from "@/script/runAsync.mjs";
import Modal from '@/components/Modal/Modal.jsx';
import Table from '@/biz/Table.jsx';
import dict from '@/script/dict.mjs';

// 模型弹出框
const Pane = ({ prjId, sVer, onOk, oprType, ...props }) => {
    const http = useHTTP();
    const [data, setData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        init();
    }, []);

    const init = async () => {
        try {
            setLoading(true);
            let pblType = null;
            let patternStsCode = 'RLS';

            if ('createBaseline' == oprType) {
                pblType = 'BASELINE';
            } else if ('createIncrement' == oprType) {
                // pblType = 'INCREMENT';
            }

            const data = await runAsync(
                async () => {
                    return await http.get(`/prjbaselines/listPattern`, { prjId, sVer, patternStsCode, pblType });
                }, {
                error: { content: (err) => `查询失败: ${err.message}` },
                loading: { show: false },
                success: { show: false },
            });

            // setData('createNew' == oprType ? data : data.filter(v => v.patternRev > 0));
            setData(data.filter(v => v.patternRev > 0));
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    }

    const handleOk = () => {
        if (selectedRows.length > 0) {
            onOk(selectedRows[0]);
        }
    }

    const rowSelection = {
        selectedRowKeys: selectedRows.map(({ pkid }) => pkid),
        onChange: (selectedRowKeys, selectedRows) => {
            setSelectedRows(selectedRows);
        },
    }

    const columns = [
        {
            title: '项目编号',
            dataIndex: 'prjNo',
            width: 100,
            filter: <Table.FilterText />,
        },
        {
            title: '分支号',
            dataIndex: 'sVer',
            width: 100,
            filter: <Table.FilterText />,
        },
        {
            title: '分支类型',
            dataIndex: 'pblType',
            width: 100,
            filter: <Table.FilterText />,
            getValue: record => dict.getDictDtl('PRJ_BASELINE', record.pblType)?.nameCn ?? record.pblType,
        },
        {
            title: '模型成品版本号',
            dataIndex: 'patternRev',
            width: 100,
            filter: <Table.FilterText />,
        },
        // {
        //     title: '模型成品标题',
        //     dataIndex: 'patternTitle',
        //     width: 100,
        //     filter: <Table.FilterText />,
        // },
    ];

    return (
        <Modal
            title={"选择模型制品"}
            width={800}
            style={{ top: 20 }}
            bodyStyle={{ overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '80vh', minHeight: 320, background: '#fff', padding: 12 }}
            onOk={handleOk}
            {...props}
        >
            <Table
                columns={columns}
                loading={loading}
                dataSource={data}
                rowKey={"pkid"}
                rowSelection={{ type: "radio", ...rowSelection }}
            />
        </Modal>
    );
}

export default Pane;